import * as types from '../../mutation_type'
import getDate from '../../../../apis/api'

export default {
  loginByAccount ({state, commit}, params) {
    state.canPush = false
    return getDate.GET_LOGINBYACCOUNTN(params).then((res) => {
      if (res.data.status == '001') {
        commit(types.LOGINBYACCOUNT, res)
        state.canPush = true
        state.personalDetails = res.data.data
      } else {
        state.checkErrorMessage = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  registerByAccount ({state, commit}, params) {
    state.canPush = false
    return getDate.GET_REGISTERBYACCOUNT(params).then((res) => {
      if (res.data.status == '001') {
        state.canPush = true
      } else {
        commit(types.REGISTERBYACCOUNT, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getCheckcodeToRegister ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_CHECKCODETOREGISTER(params).then((res) => {
        commit(types.GETCHECKCODETOREGISTER, res)
        resolve(res)
      }).catch((thrown) => {
        console.log(thrown)
        reject(thrown)
      })
    })
  },
  checkAccountVal ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
        return getDate.GET_CHECKACCOUNTVAL(params).then((res) => {
          resolve(res)
          if (res.data.status == '001') {
            state.registeringshow = true
            commit(types.CHECKACCOUNTVAL, res)
          } else {
            commit(types.CHECKACCOUNTVAL, res)
          }
        }).catch((thrown) => {
          console.log(thrown)
        })
      })
  },
  loginOrRegisterInitByWX ({state, commit}, params) {
    state.showQcodeUrl = true
     return new Promise(function (resolve, reject) {
      return getDate.GET_LOGINORREGISTERINITBYWX(params).then((res) => {
        resolve(res)
      if (res.data.status == '001') {
        state.showQcodeUrl = false
        commit(types.LOGINORREGISTERINITBYWX, res)
      }
      // 提示错误
    }).catch((thrown) => {
      console.log(thrown)
    })
  })
  },
  loginOrRegisterByWX ({state, commit}, params) {
    state.canIndexPush = false
    params.unicode = state.uniqcode
    return new Promise(function (resolve, reject) {
      return getDate.GET_LOGINORREGISTERBYWX(params).then((res) => {
        resolve(res)
      commit(types.LOGINORREGISTERBYWX, res)
     }).catch((thrown) => {
      console.log(thrown)
     })
    })
  },
  addForgetPasswordStep ({state, commit}, params) {
    state.forgetPasswordStep = params
  },
  reduceForgetPasswordStep ({state, commit}, params) {
    state.forgetPasswordStep = params
  },
  getMemberinfo ({state, commit}, params) {
     return new Promise(function (resolve, reject) {
      return getDate.GET_GETMEMBERINFO(params).then((res) => {
        resolve(res)
        commit(types.GETMEMBERINFO, res)
      // 提示错误
    }).catch((thrown) => {
      reject(thrown)
    })
  })
  },
    // 退登
    loginOut ({state, commit}, params) {
      return new Promise(function (resolve, reject) {
       return getDate.GET_LOGINOUT(params).then((res) => {
         resolve(res)
       // 提示错误
     }).catch((thrown) => {
       reject(thrown)
     })
   })
   }
}



// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/store/modules/login/actions/actions.js